module.exports = __webpack_public_path__ + "static/media/more-options-highlighted.c063eb58.svg";